import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterModule } from 'app/partials/footer/footer.module';
import { MainNavbarModule } from 'app/partials/main-navbar/main-navbar.module';
import { PricingLandingModule } from 'app/partials/pricing/pricing.module';
import { WipperozNumbersModule } from 'app/partials/wipperoz-numbers/wipperoz-numbers.module';
import { PricingRoutingModule } from './pricing-routing.module';
import { PricingComponent } from './pricing.component';

@NgModule({
  declarations: [PricingComponent],
  imports: [
    CommonModule,
    PricingRoutingModule,
    MainNavbarModule,
    FooterModule,
    PricingLandingModule,
    WipperozNumbersModule
  ],
  exports: []
})
export class PricingModule {}
